import React, { useEffect, useState, useRef, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button } from 'Components';
// Components
import Modal, { ModalBody, ModalFooter } from 'Components/Modal';
import { Input, Form } from 'Components';
// Material UI
import {
  Typography
} from '@mui/material';
import { NotificationManager } from 'Components/Notifications';

// Actions
import {
  openEventAddNotesModal,
  getAvailableMediaDetail,
  updateAvailableMedia,
  clearRedux,
} from 'Redux/actions'
import { useIntl } from 'react-intl';

const AddNote = ({ updateEvent }) => {
  const { messages } = useIntl();
  const dispatch = useDispatch();
  const videoDetailForm = useRef();

  const {
    openAddNotesModal: open,
    addNotesModalData: data
  } = useSelector((state) => state.eventsRedux);

  const {
    mediaResponse,
    loadingAvailableMedia,
    updateAvailableMediaResponse: updateResponse,
    loadingUpdateAvailableMedia: loadingUpdate
  } = useSelector(state => state.videoDetailRedux);

  const [currentNote, setCurrentNote] = useState('');

  const handleNote = () => {
    // updateEvent(data, currentNote)
    dispatch(updateAvailableMedia({
      id: data?.id,
      deviceId: data?.deviceId,
      notes: currentNote,
      starred: mediaResponse.reading?.starred || false,
      mediaDeleted: mediaResponse.reading?.mediaDeleted || false
    }))
  }

  useEffect(() => {
    if (updateResponse[data?.id]) return
    // callback()
  }, [updateResponse[data?.id]])

  useEffect(() => {
    if (updateResponse[data?.id] && open) {
      handleClose();
    }
  }, [updateResponse[data?.id], open]);

  useEffect(() => {
    if (open && data?.id) {
      dispatch(getAvailableMediaDetail(data));
    }
  }, [open, data]);

  useEffect(() => {
    if (mediaResponse && mediaResponse.reading?.notes && open) {
      setCurrentNote(mediaResponse?.reading?.notes || "");
    }
  }, [open, mediaResponse]);

  const handleClose = useCallback(() => {
    setCurrentNote("");
    dispatch(openEventAddNotesModal({ open: false, data: null }));
    dispatch(clearRedux("VIDEO_DETAIL", { updateAvailableMediaResponse: {}, mediaResponse: null }));
  });

  return (
    <Modal
      size="small"
      position="right"
      open={open}
      title={mediaResponse?.reading?.notes ? messages['videoClipRequest_updateNote'] : messages['videoClipRequest_addNote']}
      loading={loadingAvailableMedia || loadingUpdate[data?.id]}
      handleClose={handleClose}
    >
      <ModalBody>
        <div
          style={{ padding: 24, height: 450 }}
        >
          <Typography
            variant="subtitle2"
            color="textSecondary"
          >
            {data?.label}
          </Typography>

          <Form ref={videoDetailForm}>
            <Input
              label={messages['videoMainView_note']}
              placeholder={messages['videoMainView_note']}
              type="textarea"
              value={currentNote}
              maxLength={1000}
              onChange={(value) => setCurrentNote(value)}
            />
          </Form>
        </div>
      </ModalBody>
      <ModalFooter style={{ boxShadow: "2px 2px 2px 1px rgb(2 0 0 / 94%)" }}>
        <Button
          type="button"
          onClick={(e) => {
            if (e) e.preventDefault();
            handleClose()
          }}
          className="btn-cancel"
          disabled={loadingUpdate[data?.id] || loadingAvailableMedia}
        >
          {messages['cancel']}
        </Button>
        <Button
          type="button"
          onClick={(e) => {
            if (e) e.preventDefault();
            handleNote();
          }}
          className="btn-blue"
          disabled={loadingUpdate[data?.id] || loadingAvailableMedia}
        >
          {mediaResponse?.reading?.notes
            ? messages['update']
            : messages['add']
          }
        </Button>
      </ModalFooter>
    </Modal>
  )
}

export default AddNote;